import {
    Button,
    Col,
    DatePicker,
    Form,
    InputNumber,
    Row,
    Select,
    Typography
} from "antd";
import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addLoan } from "../../redux/rtk/features/loan/loanSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import { getAllLoan } from "../../redux/rtk/features/loan/loanSlice";

const { Title } = Typography;

const AddLoan = () => {
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    const staffList = useSelector((state) => state.users?.list);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadAllStaff({ status: true }));
    }, [dispatch]);
    const formatDate = (date) => {
        return dayjs(date)
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      };

    const handleFormSubmit = (values) => {
        const formData = {
            ...values,
            startDate: formatDate(values.startDate),
            returnDate: values.returnDate?.utc(),
        };

        setLoader(true);

        // Assuming you have an addLoan action to handle form submission
        dispatch(addLoan(formData))
            .then(() => {
                setLoader(false);
                form.resetFields();
                toast.success("Loan added successfully!");
                dispatch(getAllLoan());
            })
            .catch(() => {
                setLoader(false);
                toast.error("Error adding loan");
            });
    };

    return (
        <Fragment>
            <Row justify="center">
                <Col span={24}>
                    {/* <Title level={3} className="text-center">
                        Add Loan
                    </Title> */}
                    <Form
                        form={form}
                        layout="vertical"
                        name="add-loan-form"
                        onFinish={handleFormSubmit}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="Employee"
                            name="userId"
                            rules={[{ required: true, message: "Please select an employee!" }]}
                        >
                            <Select placeholder="Select Employee" showSearch allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }>
                                {staffList?.map((staff) => (
                                    <Select.Option key={staff.id} value={staff.id}>
                                        {/* {staff.userName} */}
                                        {`${staff.firstName} ${staff.lastName}`}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {/* <Form.Item
                            label="Loan Name"
                            name="loanName"
                            rules={[
                                { required: true, message: "Please enter the loan Name!" },
                            ]}
                        >
                            <Input placeholder="Enter loan Name" />
                        </Form.Item> */}

                        <Form.Item
                            label="Start Date"
                            name="startDate"
                            rules={[{ required: true, message: "Please select the start date!" }]}
                        >
                            <DatePicker format="YYYY-MM-DD" />
                        </Form.Item>

                        <Form.Item
                            label="Loan Amount"
                            name="loanAmount"
                            rules={[{ required: true, message: "Please enter the loan amount!" }]}
                        >
                            <InputNumber placeholder="Enter loan amount" />
                        </Form.Item>

                        {/* <Form.Item
                            label="EMI Value"
                            name="EMI_Value"
                            rules={[{ required: true, message: "Please enter the EMI value!" }]}
                        >
                            <InputNumber placeholder="Enter EMI value" />
                        </Form.Item> */}

                        {/* <Form.Item
                            label="Return Amount"
                            name="returnAmount"
                            rules={[
                                { required: true, message: "Please enter the return amount!" },
                            ]}
                        >
                            <Input type="number" placeholder="Enter return amount" />
                        </Form.Item> */}

                        {/* <Form.Item
                            label="Return Date"
                            name="returnDate"
                            rules={[{ required: true, message: "Please select the return date!" }]}
                        >
                            <DatePicker format="YYYY-MM-DD" />
                        </Form.Item> */}

                       

                        <Form.Item
                            label="Total Months to Return"
                            name="totalMonthReturn"
                            rules={[
                                { required: true, message: "Please enter the total months!" },
                            ]}
                        >
                            <InputNumber placeholder="Enter total months to return" />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loader}
                                block
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    );
};

export default AddLoan;
